<template>
  <PageView :loading="loading" :logo="logo" header-class="bg-light" class="bg-light d-flex flex-column flex-grow-1" container-class="d-flex flex-column flex-grow-1">
    <div class="card d-flex flex-column flex-grow-1" v-if="participation">
      <div class="card-body pt-0 px-0 d-flex flex-column flex-grow-1">
        <TravelBannerComponent :participation="participation" />

        <div class="row m-3 mt-0 d-flex flex-column flex-grow-1">
          <h2 class="card-title text-center my-4 d-flex justify-content-between flex-column flex-md-row">
            <div class="col text-start">
              <router-link custom :to="{ name: 'home' }" v-slot="{ navigate }">
                <button
                  class="btn btn-outline-primary text-nowrap d-none d-md-block"
                  @click="navigate"
                >
                  <i class="fa-solid fa-angle-left me-2"></i> Retour
                </button>
              </router-link>
            </div>
            <div>Carnet de voyage</div>
            <div class="col"></div>
            <div class="col text-start d-block d-md-none mt-2">
              <router-link custom :to="{ name: 'home' }" v-slot="{ navigate }">
                <button class="btn btn-outline-primary text-nowrap" @click="navigate">
                  <i class="fa-solid fa-angle-left me-2"></i> Retour
                </button>
              </router-link>
            </div>
          </h2>

          <!-- Pas de roadbook -->
          <div v-if="!pdfSource" class="text-center py-5">
            <i class="fa-solid fa-file-pdf fa-3x text-muted mb-3"></i>
            <p class="text-muted fs-5">Aucun carnet de voyage disponible pour ce séjour.</p>
            <router-link :to="{ name: 'home' }" class="btn btn-primary mt-2">
              <i class="fa-solid fa-angle-left me-2"></i> Retour à l'accueil
            </router-link>
          </div>

          <!-- Viewer PDF -->
          <div v-else-if="pdfSource">
            <!-- Ajouter un bouton pour telecharger le document-->
            <div class="mb-3 text-end">
              <a :href="pdfSource" class="btn btn-primary" target="_blank" rel="noopener noreferrer">
                <i class="fa-solid fa-download me-2"></i> Télécharger
              </a>
            </div>

            <!-- Zone de rendu PDF -->
            <div style="height: 75vh;">
              <iframe :src=" `https://docs.google.com/viewer?url=${encodeURIComponent(pdfSource)}&embedded=true`" style="width: 100%; height: 100%;" frameborder="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageView>
</template>

<script setup lang="ts">
import { onMounted, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/stores/notificationStore'
import { getFileUrl, getPictureUrl } from '@/compositions/helper'
import travelApi from '@/api/travelApi'
import PageView from '@/views/PageView.vue';

const router = useRouter()
const notificationsStore = useNotificationsStore()

const props = defineProps<{ id?: number; slug?: string }>()

const loading = ref(true)
const participation = ref<UserParticipation | null>(null)

// PDF source URL
const pdfSource = computed(() => {
  const roadBook = participation.value?.travel.roadBook
  if (!roadBook?.key) return null
  return getFileUrl(roadBook.key)
})

// Computed
const logo = computed(() => {
  if (participation.value?.travel.logo?.key) {
    return getPictureUrl(participation.value.travel.logo.key)
  }
  return undefined
})

onMounted(() => {
  const loadParticipation = props.id
    ? travelApi.getParticipation(Number(props.id))
    : props.slug
      ? travelApi.getParticipationBySlug(props.slug)
      : null

  if (!loadParticipation) {
    router.push({ name: 'home' })
    return
  }

  loadParticipation
    .then((response) => {
      participation.value = response.data
    })
    .catch((error: Error) => {
      notificationsStore.notifyError('Erreur lors du chargement de la page',error.message)
      router.push({ name: 'home' })
    })
    .finally(() => {
      loading.value = false
    })
})
</script>
